import request from '@/utils/request'
import type { AxiosResponse } from 'axios'
import type { LaravelPaginated, LaravelResource } from '../types'
import type { Update } from '@/models/Update'

/** GET /api/v2/updates — paginated */
export function listUpdates(limit: number): Promise<AxiosResponse<LaravelPaginated<Update>>> {
  return request({
    url: '/api/v2/updates?limit=' + limit,
    method: 'get',
  })
}

/** GET /api/v2/admin/updates — paginated */
export function listUpdatesForAdmin(
  limit: number,
): Promise<AxiosResponse<LaravelPaginated<Update>>> {
  return request({
    url: '/api/v2/admin/updates?limit=' + limit,
    method: 'get',
  })
}

/** POST /api/v2/admin/updates */
export function createUpdate(
  update: Partial<Update>,
): Promise<AxiosResponse<LaravelResource<Update>>> {
  return request({
    url: '/api/v2/admin/updates',
    method: 'post',
    data: update,
  })
}

/** PUT /api/v2/admin/updates/{id} */
export function updateUpdate(
  update: Update,
): Promise<AxiosResponse<LaravelResource<Update>>> {
  return request({
    url: '/api/v2/admin/updates/' + update.id,
    method: 'put',
    data: update,
  })
}
